import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={105.491}
      height={132.765}
      viewBox="0 0 105.491 132.765"
      {...props}
    >
      <g data-name="Group 56">
        <path
          data-name="Path 106"
          d="M30.939 82.75a17.964 17.964 0 017.274 14.537v4.635h29.042v-3.51a20.356 20.356 0 017.956-16.171 37.012 37.012 0 10-44.272.509z"
          fill="#ffc964"
        />
        <path
          data-name="Path 107"
          d="M36.125 82.75a37.013 37.013 0 0119.2-66.837 37.966 37.966 0 00-2.272-.091A37.014 37.014 0 0030.941 82.75a17.964 17.964 0 017.274 14.537v4.635h5.186v-4.635a17.963 17.963 0 00-7.276-14.537z"
          fill="#f3a334"
        />
        <path
          data-name="Path 108"
          d="M45.345 122.229c1.063 5.059 3.969 8.692 7.39 8.692s6.327-3.633 7.39-8.692z"
          fill="#4b98d4"
        />
        <path
          data-name="Path 109"
          d="M50.498 122.229h-5.153c1.063 5.059 3.969 8.692 7.39 8.692a5.12 5.12 0 002.577-.721c-2.248-1.299-4.032-4.247-4.814-7.971z"
          fill="#2472b2"
        />
        <path
          data-name="Path 110"
          d="M68.037 100.626H37.432a2.234 2.234 0 00-2.234 2.234v9.635a10.6 10.6 0 0010.6 10.6h13.869a10.6 10.6 0 0010.6-10.6v-9.635a2.234 2.234 0 00-2.23-2.234z"
          fill="#e4e3e1"
        />
        <path
          data-name="Path 111"
          d="M40.384 112.495v-9.635a2.234 2.234 0 012.234-2.234h-5.186a2.234 2.234 0 00-2.234 2.234v9.635a10.6 10.6 0 0010.6 10.6h5.186a10.6 10.6 0 01-10.6-10.6z"
          fill="#d1d0cf"
        />
        <path
          data-name="Path 112"
          d="M35.198 111.862v.633a10.6 10.6 0 0010.6 10.6h13.869a10.6 10.6 0 0010.6-10.6v-.633z"
          fill="#d1d0cf"
        />
        <path
          data-name="Path 113"
          d="M40.384 112.495v-.633h-5.186v.633a10.6 10.6 0 0010.6 10.6h5.186a10.6 10.6 0 01-10.6-10.6z"
          fill="#c1c1c1"
        />
        <path
          data-name="Path 114"
          d="M58.891 52.479l-2.771-4.8a.709.709 0 00-.614-.355h-5.542a.709.709 0 00-.614.355l-2.771 4.8a.71.71 0 000 .709l2.771 4.8a.709.709 0 00.614.355h5.542a.709.709 0 00.614-.355l2.771-4.8a.71.71 0 000-.709z"
          fill="#4b98d4"
        />
        <path
          data-name="Path 115"
          d="M76.07 49h-4.141a1.086 1.086 0 01-1.049-.823 18.625 18.625 0 00-2.022-4.877 1.086 1.086 0 01.159-1.325l2.93-2.93a1.08 1.08 0 000-1.528l-3.895-3.895a1.081 1.081 0 00-1.528 0l-2.93 2.93a1.087 1.087 0 01-1.325.159 18.613 18.613 0 00-4.877-2.022 1.086 1.086 0 01-.823-1.049v-4.141a1.081 1.081 0 00-1.08-1.081h-5.508a1.081 1.081 0 00-1.081 1.081v4.141a1.086 1.086 0 01-.823 1.049 18.618 18.618 0 00-4.873 2.026 1.087 1.087 0 01-1.325-.159l-2.93-2.93a1.08 1.08 0 00-1.528 0l-3.895 3.895a1.08 1.08 0 000 1.528l2.93 2.93a1.086 1.086 0 01.159 1.325 18.612 18.612 0 00-2.022 4.877 1.086 1.086 0 01-1.049.823h-4.141a1.081 1.081 0 00-1.081 1.081v5.508a1.081 1.081 0 001.081 1.081h4.141a1.086 1.086 0 011.049.823 18.625 18.625 0 002.022 4.877 1.087 1.087 0 01-.159 1.325l-2.93 2.93a1.081 1.081 0 000 1.528l3.895 3.895a1.08 1.08 0 001.528 0l2.93-2.93a1.087 1.087 0 011.325-.159 18.621 18.621 0 004.877 2.022 1.085 1.085 0 01.823 1.049v4.141a1.081 1.081 0 001.081 1.081h5.508a1.08 1.08 0 001.08-1.081v-4.141a1.086 1.086 0 01.823-1.049 18.616 18.616 0 004.877-2.022 1.087 1.087 0 011.325.159l2.93 2.93a1.08 1.08 0 001.528 0l3.895-3.895a1.081 1.081 0 000-1.528l-2.93-2.93a1.086 1.086 0 01-.16-1.325 18.606 18.606 0 002.022-4.877 1.086 1.086 0 011.049-.823h4.142a1.081 1.081 0 001.081-1.081v-5.508A1.08 1.08 0 0076.07 49zM52.734 64.574a11.74 11.74 0 1111.74-11.74 11.74 11.74 0 01-11.74 11.74z"
          fill="#003586"
        />
        <path
          data-name="Path 116"
          d="M54.535 57.988l-2.771-4.8a.709.709 0 010-.709l2.771-4.8a.71.71 0 01.614-.355h-5.186a.709.709 0 00-.614.355l-2.771 4.8a.709.709 0 000 .709l2.771 4.8a.71.71 0 00.614.355h5.186a.71.71 0 01-.614-.355z"
          fill="#2472b2"
        />
        <path
          data-name="Path 117"
          d="M38.704 68.153a1.08 1.08 0 010-1.528l2.93-2.93a1.086 1.086 0 00.159-1.325 18.617 18.617 0 01-2.022-4.877 1.085 1.085 0 00-1.049-.823h-4.138a1.081 1.081 0 01-1.08-1.082V50.08a1.081 1.081 0 011.081-1.081h4.141a1.086 1.086 0 001.049-.823 18.625 18.625 0 012.022-4.877 1.087 1.087 0 00-.159-1.325l-2.93-2.93a1.08 1.08 0 010-1.528l2.066-2.066-1.829-1.829a1.08 1.08 0 00-1.528 0l-3.895 3.895a1.081 1.081 0 000 1.528l2.93 2.93a1.086 1.086 0 01.159 1.325 18.613 18.613 0 00-2.022 4.877 1.085 1.085 0 01-1.049.823h-4.141a1.081 1.081 0 00-1.081 1.081v5.508a1.081 1.081 0 001.081 1.081h4.141a1.086 1.086 0 011.049.823 18.625 18.625 0 002.022 4.877 1.086 1.086 0 01-.159 1.325l-2.93 2.93a1.08 1.08 0 000 1.528l3.895 3.895a1.08 1.08 0 001.528 0l1.829-1.829z"
          fill="#2472b2"
        />
        <path
          data-name="Path 118"
          d="M49.981 28.415a1.081 1.081 0 00-1.081 1.081v4.141a1.074 1.074 0 01-.427.853 13.385 13.385 0 014.7-.837.949.949 0 00.915-.947v-3.21a1.081 1.081 0 011.081-1.081h-5.186z"
          fill="#2472b2"
        />
      </g>
      <g data-name="Group 58">
        <path
          data-name="Path 119"
          d="M44.908 54.072l2.771 4.8a2.661 2.661 0 002.3 1.328h5.545a2.66 2.66 0 002.3-1.327l2.771-4.8a2.661 2.661 0 000-2.655l-2.771-4.8a2.661 2.661 0 00-2.3-1.327h-5.542a2.661 2.661 0 00-2.3 1.327l-2.771 4.8a2.662 2.662 0 00-.003 2.654zm5.782-4.891h4.116l2.058 3.564-2.058 3.564h-4.115l-2.058-3.564z"
        />
        <path
          data-name="Path 120"
          d="M46.969 29.41v3.481a20.559 20.559 0 00-4.172 1.73l-2.463-2.463a3.03 3.03 0 00-4.279 0l-3.894 3.894a3.026 3.026 0 000 4.279l2.463 2.463a20.559 20.559 0 00-1.73 4.172h-3.482a3.029 3.029 0 00-3.025 3.025v5.508a3.029 3.029 0 003.025 3.025h3.481a20.541 20.541 0 001.73 4.172l-2.463 2.463a3.029 3.029 0 000 4.279l3.895 3.895a3.026 3.026 0 004.279 0l2.463-2.463a20.553 20.553 0 004.172 1.73v3.481a3.029 3.029 0 003.026 3.025h5.508a3.029 3.029 0 003.025-3.025V72.6a20.582 20.582 0 004.172-1.73l2.463 2.463a3.029 3.029 0 004.279 0l3.895-3.895a3.029 3.029 0 000-4.278l-2.463-2.463a20.528 20.528 0 001.73-4.172h3.481A3.029 3.029 0 0079.11 55.5v-5.508a3.029 3.029 0 00-3.025-3.025h-3.481a20.549 20.549 0 00-1.73-4.172l2.463-2.463a3.026 3.026 0 000-4.278l-3.895-3.9a3.029 3.029 0 00-4.278 0L62.7 34.623a20.55 20.55 0 00-4.172-1.73v-3.481a3.029 3.029 0 00-3.025-3.025h-5.508a3.029 3.029 0 00-3.026 3.023zm3.889.864h3.78v3.277a3.031 3.031 0 002.285 2.933 16.7 16.7 0 014.368 1.811 3.03 3.03 0 003.691-.457l2.319-2.319 2.673 2.673-2.319 2.319a3.032 3.032 0 00-.457 3.692 16.668 16.668 0 011.811 4.369 3.031 3.031 0 002.933 2.285h3.28v3.78h-3.28a3.031 3.031 0 00-2.933 2.286 16.679 16.679 0 01-1.811 4.368 3.031 3.031 0 00.458 3.69l2.319 2.319-2.673 2.673-2.319-2.319a3.031 3.031 0 00-3.691-.457 16.685 16.685 0 01-4.368 1.811 3.03 3.03 0 00-2.285 2.933v3.278h-3.78v-3.278a3.03 3.03 0 00-2.285-2.933 16.686 16.686 0 01-4.368-1.811 3.032 3.032 0 00-3.692.457l-2.318 2.319-2.673-2.673 2.32-2.319a3.031 3.031 0 00.457-3.691 16.687 16.687 0 01-1.811-4.368 3.03 3.03 0 00-2.933-2.286h-3.278v-3.78h3.278a3.031 3.031 0 002.933-2.285 16.7 16.7 0 011.811-4.368 3.031 3.031 0 00-.457-3.691l-2.319-2.319 2.673-2.673 2.319 2.32a3.033 3.033 0 003.691.457 16.682 16.682 0 014.367-1.811 3.03 3.03 0 002.286-2.933z"
        />
        <path
          data-name="Path 121"
          d="M39.064 52.746a13.685 13.685 0 1013.685-13.685 13.7 13.7 0 00-13.685 13.685zm13.685-9.8a9.8 9.8 0 11-9.8 9.8 9.807 9.807 0 019.8-9.796z"
        />
        <g data-name="Group 57">
          <path
            data-name="Path 122"
            d="M105.491 52.746a1.944 1.944 0 00-1.945-1.945h-6.119a1.945 1.945 0 000 3.889h6.118a1.944 1.944 0 001.946-1.944z"
          />
          <path
            data-name="Path 123"
            d="M0 52.746a1.944 1.944 0 001.945 1.945h6.118a1.945 1.945 0 000-3.889H1.945A1.944 1.944 0 000 52.746z"
          />
          <path
            data-name="Path 124"
            d="M92.414 32.089l5.3-3.059a1.945 1.945 0 10-1.945-3.368l-5.3 3.059a1.945 1.945 0 101.945 3.368z"
          />
          <path
            data-name="Path 125"
            d="M9.723 79.83l5.3-3.059a1.945 1.945 0 10-1.945-3.368l-5.3 3.059a1.945 1.945 0 101.945 3.368z"
          />
          <path
            data-name="Path 126"
            d="M76.771 15.021l3.059-5.3a1.945 1.945 0 10-3.368-1.945l-3.059 5.3a1.945 1.945 0 003.368 1.945z"
          />
          <path
            data-name="Path 127"
            d="M54.69 8.063V1.945a1.945 1.945 0 10-3.889 0v6.118a1.945 1.945 0 103.889 0z"
          />
          <path
            data-name="Path 128"
            d="M28.72 15.022a1.945 1.945 0 003.368-1.945l-3.059-5.3a1.945 1.945 0 10-3.368 1.945z"
          />
          <path
            data-name="Path 129"
            d="M13.077 32.088a1.945 1.945 0 101.945-3.368l-5.3-3.059a1.945 1.945 0 10-1.945 3.368z"
          />
          <path
            data-name="Path 130"
            d="M90.469 76.771l5.3 3.059a1.945 1.945 0 101.945-3.368l-5.3-3.059a1.945 1.945 0 10-1.945 3.368z"
          />
          <path
            data-name="Path 131"
            d="M55.353 15.775a1.944 1.944 0 001.694 2.166 34.95 34.95 0 0130.5 30.5 1.945 1.945 0 003.86-.472 39 39 0 00-33.892-33.888 1.945 1.945 0 00-2.162 1.694z"
          />
          <path
            data-name="Path 132"
            d="M76.405 83.697a39.164 39.164 0 0015.009-26.178 1.944 1.944 0 00-3.86-.472 35.251 35.251 0 01-13.51 23.562 22.429 22.429 0 00-8.718 17.984H40.169v-1.394a19.95 19.95 0 00-8.072-16.108 35.068 35.068 0 0116.351-63.147 1.945 1.945 0 00-.478-3.86 38.957 38.957 0 00-18.165 70.149 16.048 16.048 0 016.476 12.966v1.562a4.183 4.183 0 00-3.015 4.011v9.633a12.566 12.566 0 0010.571 12.39c3.414 10.621 14.4 10.628 17.82 0a12.566 12.566 0 0010.571-12.39v-9.635a4.184 4.184 0 00-3.016-4.011 18.532 18.532 0 017.193-15.062zm-8.356 18.785a.29.29 0 01.289.289v7.057H37.154v-7.057a.29.29 0 01.289-.289zm-8.369 18.582H45.814a8.689 8.689 0 01-8.558-7.346h30.985a8.685 8.685 0 01-8.561 7.346zm-11.619 3.889h9.37c-2.417 5.229-6.952 5.229-9.37.001z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
